angular.module('b2cApp.controllers').controller('RedirectController', function ($scope, $window, $document) {
    $scope.DEFAULT_REDIRECT_MILLISECONDS = 3 * 1000;

    $scope.redirect = function(redirectUrl) {
        $document.ready(function () {
            if (redirectUrl !== undefined) {
                setTimeout(function () {
                    const queryString = $window.location.search;
                    const url = new URL(redirectUrl, $window.location.origin);
                    url.search = queryString;
                    $window.location = url.toString();
                }, $scope.DEFAULT_REDIRECT_MILLISECONDS);
            }
        });
    };
});
